const toKMBT = (value) => {
    if (value >= 1_000_000_000_000) {
        return (value / 1_000_000_000_000) + "T"; // Triliun
    } else if (value >= 1_000_000_000) {
        return (value / 1_000_000_000) + "B"; // Miliar
    } else if (value >= 1_000_000) {
        return (value / 1_000_000) + "M"; // Juta
    } else if (value >= 1_000) {
        return (value / 1_000) + "K"; // Ribuan
    }
    return value.toString(); // Di bawah ribuan
};

export default toKMBT;